import React, { useMemo, useEffect, useState } from "react";
//Import Breadcrumb
import { Container } from "reactstrap";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
} from "../../../components/shared/dialog";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../../../components/shared/alertDialog";

import "react-toastify/dist/ReactToastify.css";
import Paginate from "../../../components/shared/paginate";
import { toast } from "react-toastify";
import {
  CreateRole,
  DeleteRole,
  FetchPrivileges,
  FetchRoles,
  UpdateRole,
} from "../../../apis/adminRoles";

const ManageAdminRoles = () => {
  const [roles, setRoles] = useState([]);
  const [filteredRoles, setFilteredRoles] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [currentPage, setCurrentPage] = useState("1");
  const [totalPages, setTotalPages] = useState("1");
  const limit = "10";
  // dialog variables
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [roleId, setRoleId] = useState("");
  const [roleName, setRoleName] = useState("");
  const [description, setDescription] = useState("");
  const [privileges, setPrivileges] = useState([]);
  // alertDialog variables
  const [openAlertDialog, setOpenAlertDialog] = useState(false);

  const fetchRoles = async () => {
    try {
      const response = await FetchRoles(currentPage, limit);
      setRoles(response.data.roles);
      setFilteredRoles(response.data.roles);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      toast.error("Error fetching admin roles");
    }
  };

  const fetchPrivileges = async () => {
    const response = await FetchPrivileges();
    setPrivileges(response.data);
  };

  useEffect(() => {
    fetchPrivileges();
  }, []);

  const handlePrivilegeCheck = (privilegeSlug) => {
    const tempPrivileges = privileges.map((privilege) => {
      if (privilege.slug === privilegeSlug) {
        return {
          ...privilege,
          value: !privilege.value,
        };
      } else return privilege;
    });
    setPrivileges(tempPrivileges);
  };
  /*
  useEffect(() => {
    fetchRoles();
    fetchPrivileges();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);*/
  /*
  useEffect(() => {
    if (keyword) {
      // searchUsers();
    } else fetchRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);*/

  useEffect(() => {
    if (keyword) {
      setCurrentPage("1");
      // searchUsers();
    } else fetchRoles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyword]);

  const columns = useMemo(
    () => ["ID", "Name", "Description", "Edit", "Delete"],
    [],
  );

  const updateRole = async () => {
    try {
      const rolePrivileges = [];
      privileges.map((privilege) => {
        if (privilege.value) rolePrivileges.push(privilege.slug);
        return { privilege };
      });

      const role = {
        _id: roleId,
        name: roleName,
        description: description,
        privileges: rolePrivileges,
      };
      await UpdateRole(role);

      const tempRoles = filteredRoles.map((tempRole) => {
        if (tempRole._id === role._id) return role;
        else return tempRole;
      });

      setFilteredRoles(tempRoles);

      handlePrivilegeCheck();
      setOpenDialog(false);
      toast.success("Admin role updated");
    } catch (err) {
      setOpenDialog(false);

      toast.error("Error updating admin role");
    }
  };

  const handleDialogOpen = (role) => {
    setRoleId(role._id);
    setRoleName(role.name);
    setDescription(role.description);
    const tempPrivileges = privileges.map((privilege) => {
      let index = -1;
      for (let i = 0; i < role.privileges.length; i++) {
        if (privilege.slug === role.privileges[i]) {
          index = i;
          break;
        }
      }
      if (index > -1)
        return {
          ...privilege,
          value: true,
        };
      else
        return {
          ...privilege,
          value: false,
        };
    });
    setPrivileges(tempPrivileges);
    setDialogTitle("Edit admin role");
    setOpenDialog(true);
  };

  const handelDialogNew = () => {
    const tempPrivileges = privileges.map((privilege) => {
      return {
        ...privilege,
        value: false,
      };
    });
    setPrivileges(tempPrivileges);
    setRoleId("");
    setRoleName("");
    setDescription("");
    setDialogTitle("Add admin role");
    setOpenDialog(true);
  };

  const addRole = async () => {
    try {
      const rolePrivileges = [];
      privileges.map((privilege) => {
        if (privilege.value) rolePrivileges.push(privilege.slug);
        return { privilege };
      });

      const role = {
        name: roleName,
        description: description,
        privileges: rolePrivileges,
      };
      const result = await CreateRole(role);
      setFilteredRoles((prev) => [...prev, result.data]);
      setOpenDialog(false);
      toast.success("Admin role added");
    } catch (err) {
      setOpenDialog(false);
      toast.error("Error adding admin role");
    }
  };

  const handleRoleDelete = async (roleId) => {
    try {
      const result = await DeleteRole(roleId);
      if (result.success) {
        setFilteredRoles((prev) =>
          filteredRoles.filter((role) => {
            if (role._id !== roleId) return role;
          }),
        );
        toast.success("Admin role deleted");
      }
    } catch (err) {
      toast.error("Error deleting admin role");
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container
          //  h-[calc(100vh-130px)]
          className="px-0 dark:bg-darkBg1 dark:text-[#c7d8eb]"
          fluid
        >
          <div className="p-6 flex flex-col gap-6 ">
            <h1 className="text-2xl dark:text-[#c7d8eb]">Manage admin roles</h1>
            <button
              onClick={() => handelDialogNew()}
              className="w-fit rounded-md font-bold text-lg px-4 py-2 bg-primaryColor text-white"
            >
              Add new
            </button>
            <div className="lg:flex flex-col lg:border lg:border-b-0 border-gray-400 dark:border-white rounded-md">
              <div className="overflow-x-auto ">
                <div className="hidden lg:flex">
                  {columns.map((column, index) => (
                    <div
                      key={`column-${index}`}
                      className={`w-1/5 min-w-[130px] content-center border-b border-gray-500 dark:border-white break-words py-2 text-center font-semibold`}
                    >
                      {column}
                    </div>
                  ))}
                </div>
                {roles &&
                  filteredRoles.map((role, index) => (
                    <>
                      <div
                        key={`role-desktop-${index}`}
                        className="hidden lg:flex"
                      >
                        <div className="w-1/5 min-w-[130px] px-1 content-center border-b border-gray-500 dark:border-white break-words py-2 text-center">
                          {role._id}
                        </div>
                        <div className="w-1/5 min-w-[130px] px-1 content-center border-b border-gray-500 dark:border-white break-words py-2 text-center">
                          {role.name}
                        </div>
                        <div className="w-1/5 min-w-[130px] px-1 content-center border-b border-gray-500 dark:border-white break-words py-2 text-center">
                          {role.description}
                        </div>
                        <div className="w-1/5 min-w-[130px] px-1 flex justify-center items-center border-b border-gray-500 dark:border-white break-words py-2 text-center">
                          <div
                            onClick={() => {
                              handleDialogOpen(role);
                            }}
                            className=" text-secondaryColor cursor-pointer size-fit ="
                          >
                            Edit
                          </div>
                        </div>
                        <div className="w-1/5 min-w-[130px] px-1 content-center border-b border-gray-500 dark:border-white break-words py-2 text-center">
                          <button
                            onClick={() => {
                              setRoleId(role._id);
                              setOpenAlertDialog(true);
                            }}
                            className="text-secondaryColor"
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                      <div
                        key={`role-mobile-${index}`}
                        className="block lg:hidden mb-6 border-x border-y border-gray-500 dark:border-white"
                      >
                        <div className="flex gap-2 justify-between p-2 border-b border-gray-500 dark:border-white">
                          <div className="font-bold">ID</div>
                          <div>{role._id}</div>
                        </div>
                        <div className="flex gap-2 justify-between p-2 border-b border-gray-500 dark:border-white">
                          <div className="font-bold">Name</div>
                          <div>{role.name}</div>
                        </div>
                        <div className="flex gap-2 justify-between p-2 border-b border-gray-500 dark:border-white">
                          <div className="font-bold">Description</div>
                          <div>{role.description}</div>
                        </div>
                        <div className="flex gap-2 justify-between p-2 border-b border-gray-500 dark:border-white">
                          <div className="font-bold">Edit</div>
                          <div
                            onClick={() => {
                              handleDialogOpen(role);
                            }}
                            className="text-secondaryColor cursor-pointer"
                          >
                            Edit
                          </div>
                        </div>
                        <div className="flex gap-2 justify-between p-2 ">
                          <div className="font-bold">Delete</div>
                          <button
                            onClick={() => {
                              setRoleId(role._id);
                              setOpenAlertDialog(true);
                            }}
                            className="text-secondaryColor"
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </>
                  ))}
              </div>
            </div>
            <Paginate
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
            />
            <Dialog open={openDialog} onOpenChange={setOpenDialog}>
              <DialogContent className="max-w-screen w-[calc(100vw-20px)] lg:ml-[120px] lg:w-[700px] max-h-[calc(100vh-calc(100vh/3))] overflow-auto select-none bg-gray-200 dark:bg-[#171d37] dark:text-[#c7d8eb]">
                <DialogHeader className={"flex flex-row"}>
                  <h2 className="dark:text-[#c7d8eb] min-w-fit">
                    {dialogTitle}
                  </h2>
                  <div className="w-full flex justify-end">
                    <button
                      className="cursor-pointer dark:text-[#c7d8eb]"
                      onClick={() => {
                        setOpenDialog(false);
                      }}
                      size={30}
                    >
                      X
                    </button>
                  </div>
                </DialogHeader>
                <hr className="border-t-[rgba(0,0,0,0.6)] dark:border-t-[rgba(255,255,255,0.6)] -mt-3" />
                <div className="flex w-full flex-col">
                  <h2 className="text-xl dark:text-[#c7d8eb]">
                    <label htmlFor="roleName">Role name</label>
                  </h2>
                  <div className="flex w-full justify-between">
                    <input
                      id="roleName"
                      type="text"
                      placeholder="Role name"
                      className="w-full px-4 py-3 rounded-sm dark:bg-darkBg1 border border-[rgba(0,0,0,0.6)] dark:border-t-[rgba(255,255,255,0.6)]"
                      value={roleName}
                      onChange={(e) => setRoleName(e.target.value)}
                    />
                  </div>
                </div>
                <div className="flex w-full flex-col">
                  <h2 className="text-xl dark:text-[#c7d8eb]">
                    <label htmlFor="description">Description</label>
                  </h2>
                  <div className="flex w-full justify-between">
                    <textarea
                      id="description"
                      placeholder="Description"
                      className="w-full min-h-14 max-h-40 px-4 py-3 rounded-sm dark:bg-darkBg1 border border-[rgba(0,0,0,0.6)] dark:border-t-[rgba(255,255,255,0.6)]"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </div>
                </div>
                <div className="flex w-full flex-col">
                  <h2 className="text-xl dark:text-[#c7d8eb]">
                    <label htmlFor="roleName">Privileges</label>
                  </h2>
                  <div className="flex flex-col lg:flex-row w-full flex-wrap">
                    {privileges.map((privilege, index) => (
                      <div
                        key={`privilege-${index}`}
                        className="w-full lg:w-1/2"
                      >
                        <input
                          type="checkbox"
                          id={privilege.slug}
                          name={privilege.slug}
                          checked={privilege.value}
                          onChange={() => handlePrivilegeCheck(privilege.slug)}
                        />
                        <label
                          htmlFor={privilege.slug}
                          className="ml-2 text-lg"
                        >
                          {privilege.title}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
                <hr className="border-t-[rgba(0,0,0,0.6)] dark:border-t-[rgba(255,255,255,0.6)]" />
                <DialogFooter>
                  <button
                    className="bg-primaryColor hover:bg-primaryColor text-white px-4 py-2 rounded-md text-lg font-semibold"
                    type="submit"
                    onClick={() => {
                      dialogTitle === "Edit admin role"
                        ? updateRole()
                        : addRole();
                    }}
                  >
                    {dialogTitle === "Edit admin role" ? "Update" : "Add"}
                  </button>
                </DialogFooter>
              </DialogContent>
            </Dialog>
            <AlertDialog
              open={openAlertDialog}
              onOpenChange={setOpenAlertDialog}
            >
              <AlertDialogContent className="max-w-screen w-[calc(100vw-20px)] lg:w-[700px] max-h-[calc(100vh-calc(100vh/3))] overflow-auto select-none bg-gray-200 dark:bg-[#171d37] dark:text-[#c7d8eb]">
                <AlertDialogHeader>
                  <AlertDialogTitle>
                    <h2 className="dark:text-[#c7d8eb] min-w-fit">
                      Are you sure you want to delete role
                    </h2>
                  </AlertDialogTitle>
                  <AlertDialogDescription>
                    This action cannot be undone. This will permanently delete
                    this role from the server.
                  </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter
                  className={"flex justify-end gap-2 items-center"}
                >
                  <AlertDialogCancel>
                    <div onClick={() => setOpenAlertDialog(false)}>Cancel</div>
                  </AlertDialogCancel>
                  <AlertDialogAction>
                    <div
                      className="mt-0"
                      onClick={() => handleRoleDelete(roleId)}
                    >
                      Continue
                    </div>
                  </AlertDialogAction>
                </AlertDialogFooter>
              </AlertDialogContent>
            </AlertDialog>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ManageAdminRoles;
